import { Typography } from '@eventr/common-storybook'

interface ISectionHeaderProps {
    title: string
}
export const SectionHeader = ({ title }: ISectionHeaderProps) => {
    return <Typography variant="bodyBold">{title}</Typography>
}
